import React, { useState, useEffect } from 'react';
import TransferList from './TransferList'
import TransferThreeList from './TransferThreeList'
import { Box, Button, CircularProgress, Typography, Collapse, useTheme } from '@material-ui/core'
import ChannelsTable from './channelsTable';
import InfoChannelTable from './InfoChannelTable'
import { useTranslate, useDataProvider, Loading } from 'react-admin';
import ArrowRight from '@material-ui/icons/ArrowRight';
import Snackbar from '../common/snackbar';

function scrollTop(element, change, duration) {
    var start = element.scrollTop,
        currentTime = 0,
        increment = 10;


    var animateScroll = function () {
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};

const ChannelList = ({ readOnly, from, data, permissions }) => {
    const translate = useTranslate()
    const [right, setRight] = React.useState([]);
    const [channels, setChannels] = React.useState(null)
    const [channelsAssign, setChannelsAssign] = React.useState(null)
    const [infochannels, setInfoChannels] = useState([])
    const [infoChannelsAssign, setInfoChannelsAssign] = React.useState([])
    const [rightsInfoChannels, setRightInfoChannels] = useState([])
    const [loading, setLoading] = React.useState()
    const [loadingPage, setLoadingPage] = useState()
    const [groups, setGroups] = useState([])
    const [success, setSuccess] = useState(false)
    const dataProvider = useDataProvider()
    const [openChannels, setOpenChannels] = useState(true)
    const [openInfoChannels, setOpenInfoChannels] = useState(false)
    const theme = useTheme()


    const getAllChannel = () => {
        dataProvider('GET_LIST', "channel", {
            filter: {
            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: {
                field: 'createdAt',
                order: 'DESC'
            },
        }).then(({ data, total }) => {
            // var temps = data.filter(value => assigns.findIndex(element => element.id === value.id) < 0)
            setChannels(data)
            setLoadingPage(false)
        }).catch(error => {
            setLoadingPage(false)
        });
    }



    const getChannelAssign = () => {
        setLoadingPage(true)
        dataProvider('GET_ONE', `channels/findby${from}`, {
            id: data.id
        }).then(({ data }) => {
            setChannelsAssign(data)
            getAllChannel()
        }).catch(error => {
            setLoadingPage(false)
        });
    }

    const getInfoChannelList = () => {
        dataProvider('GET_LIST', "infochannels", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setInfoChannels(data);
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
            })

    }

    const getInfoChannelAssign = () => {
        setLoading(true)
        dataProvider('GET_ONE', `infochannels/findbycluster`, {
            id: data.id
        }).then(({ data }) => {
            setInfoChannelsAssign(data)
            getInfoChannelList()

        }).catch(error => {
            setLoading(false)
        });
    }

    const getGroup = () => {
        dataProvider('GET_LIST', "channels/findgroup", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setGroups(data);
            })
            .catch(error => {

            })
    }


    const handleAddChannel = () => {
        let temps = [...channelsAssign]
        right.forEach(item => {
            if (item.id.toString().search('group-') > -1) {
                temps = temps.concat(item.channels.filter(element => temps.findIndex(e => e.id === element.id) < 0))
            }
            else if (temps.findIndex(e => e.id === item.id) < 0)
                temps.push(item)
        })
        setChannelsAssign(temps)
        setRight([])
    }

    const handleAddInfoChannel = () => {
        let temps = [...infoChannelsAssign]
        rightsInfoChannels.forEach(item => {
            temps.push(item)
        })
        setInfoChannelsAssign(temps)
        setRightInfoChannels([])
    }

    const handleDelete = (value, index) => {
        let temps = channelsAssign.slice()
        temps.splice(index, 1)
        setChannelsAssign(temps)

    }


    const handleDeleteInfoChannel = (value, index) => {
        let temps = infoChannelsAssign.slice()
        temps.splice(index, 1)
        setInfoChannelsAssign(temps)

    }

    const handleOnSave = () => {
        setLoading(true)
        var arrayId = []
        channelsAssign.forEach(value => arrayId.push(value.id))
        var infochannelId = []
        if (infoChannelsAssign && infoChannelsAssign.length > 0)
            infoChannelsAssign.forEach(value => infochannelId.push(value.id))
        dataProvider('UPDATE', `channels/assignto${from}`, {
            id: data.id,
            data: {
                channelIds: arrayId,
                infochannelIds: infochannelId
            },
        }).then(({ }) => {
            setSuccess(true)
            setLoading(false)
            scrollTop(document.getElementById(from === 'cluster' ? 'containerClusterEditDialog' : 'containerRoomEditDialog'), 0, 0);
            setTimeout(() => {
                setSuccess(false);
            }, 5000);

        }).catch(error => {
            setLoading(false)
        });
    }
    const action = (
        <Button color="secondary" size="small" onClick={() => {
            setSuccess(false)
        }}>
            {translate('resources.room.close')}
        </Button>
    );

    const readOnlyChannel = () => {
        if (!permissions.functionAction.find(value => value.function === 'Cluster channel admin' && value.isUpdate)) return true
        return false
    }

    const readOnlyInfoChannel = () => {
        if (!permissions.functionAction.find(value => value.function === 'Cluster Info Channel Admin' && value.isUpdate)) return true
        return false
    }

    const disableSave = () => {
        if (from === 'cluster' && !permissions.functionAction.find(value => value.function === 'Cluster Info Channel Admin' && value.isUpdate) &&
            !permissions.functionAction.find(value => value.function === 'Cluster channel admin' && value.isUpdate)) return true
        if (from !== 'cluster' && !permissions.functionAction.find(value => value.function === 'Cluster channel admin' && value.isUpdate)) return true
        return false
    }

    React.useEffect(() => {
        getInfoChannelAssign()
        getChannelAssign()
        getGroup()
    }, []);

    const handleOpenChannels = () => {
        setOpenChannels(!openChannels)
    }
    const handleOpenInfoChannels = () => {
        setOpenInfoChannels(!openInfoChannels)
    }


    if (loadingPage) return <Loading></Loading>
    if (channelsAssign === null || channels === null) return null


    return (
        <Box width="100%" id='container'>
            {
                success && (
                    <Box width='100%' display='flex' justifyContent='flex-end'>
                        <Box width='40%'>
                            <Snackbar
                                show={success}
                                message={translate('resources.room.saveSuccess')}
                                onClose={() => setSuccess(false)}
                            />
                        </Box>

                    </Box>
                )
            }
            <Box display='flex' onClick={() => handleOpenChannels()} style={{ cursor: 'pointer', width: 'fit-content' }}>
                <Typography variant="h5" color="textPrimary">{translate('resources.room.channelLists')}</Typography>
                <ArrowRight fontSize='large' style={{ transform: openChannels && 'rotate(90deg)', transition: 'transform 0.2s' }}></ArrowRight>
            </Box>


            <Collapse in={openChannels} timeout="auto" unmountOnExit>
                <Box mt={1}>

                    <ChannelsTable
                        readOnly={readOnlyChannel()}
                        data={channelsAssign}
                        setData={setChannelsAssign}
                        handleDelete={handleDelete}
                    />
                </Box>
                <Box mt={3}>
                    {
                        from === 'cluster' ?
                            <TransferThreeList
                                readOnly={readOnlyChannel()}
                                setLeft={setChannels}
                                left={channels}
                                groups={groups}
                                assigns={channelsAssign}
                                setGroups={setGroups}
                                handleAddChannel={handleAddChannel}
                                setRight={setRight}
                                right={right}
                            />
                            :
                            <TransferList
                                readOnly={readOnlyChannel()}
                                setLeft={setChannels}
                                left={channels}
                                handleAddChannel={handleAddChannel}
                                setRight={setRight}
                                assigns={channelsAssign}
                                right={right}
                            />

                    }

                </Box>
            </Collapse>
            {
                from === 'cluster' && (
                    <Box hidden={!permissions.functionAction.find(value => value.function === 'Cluster Info Channel Admin' && value.isRead)}>
                        <Box display='flex' onClick={() => handleOpenInfoChannels()} style={{ cursor: 'pointer', width: 'fit-content' }} mt={2}>
                            <Typography variant="h5" color="textPrimary">{translate(`pos.menu.infoChannelManagement`)}</Typography>
                            <ArrowRight fontSize='large' style={{ transform: openInfoChannels && 'rotate(90deg)', transition: 'transform 0.2s' }}></ArrowRight>
                        </Box>

                        <Collapse in={openInfoChannels} timeout="auto" unmountOnExit>
                            <Box mt={1}>
                                <InfoChannelTable
                                    readOnly={readOnlyInfoChannel()}
                                    data={infoChannelsAssign}
                                    setData={setInfoChannelsAssign}
                                    handleDelete={handleDeleteInfoChannel}
                                />
                            </Box>
                            <Box mt={3}>
                                <TransferList
                                    readOnly={readOnlyInfoChannel()}
                                    setLeft={setInfoChannels}
                                    left={infochannels}
                                    handleAddChannel={handleAddInfoChannel}
                                    setRight={setRightInfoChannels}
                                    assigns={infoChannelsAssign}
                                    right={rightsInfoChannels}
                                />
                            </Box>
                        </Collapse>

                    </Box>
                )
            }

            <Box width='100%' display='flex' justifyContent='flex-end'>

                <Button
                    disabled={disableSave()}
                    onClick={handleOnSave}
                    style={{ width: '94px', height: '36px' }}
                    variant="contained" color='primary' size='large'>
                    {loading && (
                        <CircularProgress
                            size={20}
                            thickness={2}
                            color='inherit'
                        />
                    )}
                    {translate('resources.room.save')}
                </Button>
            </Box>
        </Box >

    )
}

export default ChannelList